module.exports = __webpack_public_path__ + "img/motion-1.14ec8dbb.jpg";